import { useQuery } from '@tanstack/react-query';
import fetch from './fetch';
import { PANIC_KEYS } from './constants';

function useDtConfig() {
  const { cb, key } = fetch();
  const { data, isSuccess, refetch } = useQuery(key, cb, {
    staleTime: Infinity,
  });

  const dtPanicActivationData = data?.[PANIC_KEYS.ODT_PANIC_ACTIVATION];
  const isDtPanicActivationTriggered = data?.[PANIC_KEYS.ODT_PANIC_ACTIVATION].value === 'TRUE';
  const dtPanicActivationMessage = data?.[PANIC_KEYS.ODT_PANIC_ACTIVATION].message;

  const dtPanicCashTransferData = data?.[PANIC_KEYS.ODT_PANIC_CASH_TRANSFER];
  const isDtPanicCashTransferTriggered =
    data?.[PANIC_KEYS.ODT_PANIC_CASH_TRANSFER].value === 'TRUE';
  const dtPanicCashTransferMessage = data?.[PANIC_KEYS.ODT_PANIC_CASH_TRANSFER].message;

  const dtPanicBuySellData = data?.[PANIC_KEYS.ODT_PANIC_BUY_SELL];
  const isDtPanicBuySellTriggered = data?.[PANIC_KEYS.ODT_PANIC_BUY_SELL].value === 'TRUE';
  const dtPanicBuySellMessage = data?.[PANIC_KEYS.ODT_PANIC_BUY_SELL].message;

  return {
    isSuccess,
    refetch,
    dtPanicActivationData,
    isDtPanicActivationTriggered,
    dtPanicActivationMessage,
    dtPanicCashTransferData,
    isDtPanicCashTransferTriggered,
    dtPanicCashTransferMessage,
    dtPanicBuySellData,
    isDtPanicBuySellTriggered,
    dtPanicBuySellMessage,
  };
}

export default {
  useDtConfig,
};
